// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"animatedText-module--wrapper--2jx5J","word":"animatedText-module--word--UX-vQ","showText":"animatedText-module--showText--2K4Tf"};